import { useEffect, useState } from "react";

export default (refElement) => {
    
	const [ isIntersecting, setIsIntersecting ] = useState(true);

	useEffect(() => {
		const observer = new IntersectionObserver((entries) => {
			setIsIntersecting(entries[0].isIntersecting);
		});
		if (refElement && refElement.current){
			observer.observe(refElement.current);
		}
		return () => observer.disconnect();
	}, [ refElement ]);
	return { isIntersecting };
};
